module.exports = __webpack_public_path__ + "0d3faf805fd396b0c87d09bfddccaa82.png";